import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import Config from '../../../config';

const colorMap = {
  info: Config.Color.coolBlueDark,
  warn: Config.Color.warning,
  error: Config.Color.error,
  success: Config.Color.green,
};

const Notification = ({ message, variant = 'info' }) => {
  return (
    <Container variant={variant}>
      <IconWrapper>
        <img src={Config.ImageAssets.notifications.info} alt="icon" />
      </IconWrapper>
      <MessageWrapper>
        <Message>{message}</Message>
      </MessageWrapper>
      <Close>
        <img src={Config.ImageAssets.notifications.close} alt="close" />
      </Close>
    </Container>
  );
};

const Container = styled.div`
  color: white;
  background-color: ${(props) => colorMap[props.variant]};
  height: auto;
  text-align: center;
  padding: ${isMobile ? 0 : '8px'};
  margin: ${isMobile ? '8px 8px 0 8px' : 0};
  width: 100%;
  display: grid;
  grid-template-columns: ${isMobile ? '60px auto 60px' : '80px auto 80px'};
  grid-template-rows: auto;
  justify-items: center;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
`;

const IconWrapper = styled.div`
  align-self: center;
  margin: 12px;
`;

const Close = styled.div`
  align-self: center;
  margin: 12px;
  grid-column: ${isMobile ? '3' : '4'};
`;

const MessageWrapper = styled.div`
  align-self: center;
  justify-self: left;
  padding: 8px 0;
`;

const Message = styled.div`
  text-align: left;
  font-size: ${isMobile ? '12px' : '12px'};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
`;

export default React.memo(Notification);
